const styles = () => ({
	page: {
		width: '100%',
		height: '100%',
		display: 'flex',
		flexFlow: 'column nowrap',
		justifyContent: 'flex-end'
	},
	content: {
		flex: '1 0 auto',
		display: 'flex',
		flexFlow: 'column',
		paddingBottom: 40
	},
	overlay: {
		display: 'flex',
		flexFlow: 'column',
		height: 'calc(100% - 80px)'
	},
	'@media (max-height: 512px)': {
		overlay: {
			display: 'flex',
			flexFlow: 'column',
			height: 'calc(100% - 40px)'
		}
	},
	'@media (min-width: 1920px)': {
		overlay: {
			left: 'calc((100% - 1536px)/2)!important',
			maxWidth: '1536px'
		},
		header: {
			paddingLeft: 'calc((100% - 1536px)/2)!important',
			paddingRight: 'calc((100% - 1536px)/2)!important'
		}
	},
	'@media (min-width: 1024px)': {
		header: {
			paddingRight: '10%',
			paddingLeft: '10%',
			paddingBottom: '128px'
		},
		overlay: {
			position: 'absolute',
			left: '10%',
			top: '96px',
			width: '80%'
		},
		content: {
			paddingBottom: '40px',
			marginBottom: '16px',
			minHeight: '512px'
		},
		footer: {
			display: 'flex',
			flexFlow: 'row',
			width: '100%',
			justifyContent: 'space-between',
			alignItems: 'flex-start',
			'& p:nth-of-type(1)': {
				textAlign: 'left'
			},
			'& p:nth-of-type(2)': {
				textAlign: 'right',
				'& br': {
					display: 'none'
				}
			}
		},
		'@global html, body': {
			backgroundColor: '#EEE'
		}
	},
	'@media (max-width: 1024px)': {
		removePaperShadow: {
			boxShadow: 'none'
		}
	}
});

export default styles;




// WEBPACK FOOTER //
// ./src/client/components/main/layout/styles.js